// extracted by mini-css-extract-plugin
module.exports = {"card":"tag-item_card__2P4_m","header":"tag-item_header__1mclK"};